import { Controller } from "@hotwired/stimulus"
import React from "react";
import { createRoot } from "react-dom/client";
import StartNow from "../components/StartNow.jsx";

export default class extends Controller {
  static values = {
    eventId: Number
  };
  connect() {
    document.addEventListener("turbo:load", () => {
      if (!this.root) {
        this.root = createRoot(this.element);
      }
      this.root.render(<StartNow/>);
      const props = {
        eventId: this.hasEventIdValue ? this.eventIdValue : null,
      };
      this.root.render(<StartNow {...props} />);
    });
  }
}